document.addEventListener('DOMContentLoaded', function () {
  if (!window.bedConfigData) return;

  const data = window.bedConfigData;
  let selectedConfig = {
    fabrics: null,
    colors: null,
    size: null,
    storage: null,
    headboards: null,
    buttons: null
  };

  // 1. Grab the global mapping from the Metafield (assuming it's on a wrapper or body)
  const rootElement = document.querySelector('.bed-configurator') || document.body;
  let dynamicColorMap = {};
  if (rootElement.dataset.colorMap) {
    try {
      dynamicColorMap = JSON.parse(rootElement.dataset.colorMap);
    } catch (e) {
      console.error('Error parsing color map', e);
    }
  }

  // 2. Handle option button clicks & fabric filtering
  document.querySelectorAll('.config-option-btn').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const group = this.dataset.group;
      const key = this.dataset.key;

      document.querySelectorAll(`[data-group="${group}"]`).forEach(btn => btn.classList.remove('is-active'));
      this.classList.add('is-active');

      const matchedOption = data.options.find(opt => opt.group === group && opt.key === key);
      if (matchedOption) {
        selectedConfig[group] = matchedOption;
        
        // --- NEW METAFIELD FILTERING LOGIC ---
        if (group === 'fabrics') {
          const colorContainer = document.querySelector('[data-group-name="colors"]');
          if (colorContainer) {
            colorContainer.style.display = 'block'; 
            
            // Get the allowed colors for this specific fabric key from your App Mapping
            const allowedColorKeys = dynamicColorMap[key] || [];
            const hasMappingRules = allowedColorKeys.length > 0;
            
            colorContainer.querySelectorAll('.config-option-btn').forEach(colorBtn => {
              const colorKey = colorBtn.dataset.key;
              
              // Show if no rules exist yet, OR if the color is explicitly allowed
              if (!hasMappingRules || allowedColorKeys.includes(colorKey)) {
                colorBtn.style.display = 'inline-block';
              } else {
                colorBtn.style.display = 'none';
                colorBtn.classList.remove('is-active'); 
                
                // Clear the selection if the active color gets hidden
                if (selectedConfig.colors && selectedConfig.colors.key === colorKey) {
                  selectedConfig.colors = null;
                }
              }
            });
          }
        }
        // --- END FILTERING LOGIC ---

        recalculateTotalPrice();
      }
    });
  });

  function recalculateTotalPrice() {
    let totalPrice = data.basePrice; // in subunits
    Object.keys(selectedConfig).forEach(category => {
      const item = selectedConfig[category];
      if (item && item.upcharge) {
        totalPrice += Number(item.upcharge) * 100;
      }
    });

    const priceEl = document.querySelector('.t4s-product-price');
    if (priceEl) {
      priceEl.innerHTML = `£${(totalPrice / 100).toFixed(2)}`;
    }
    window.currentCalculatedPrice = totalPrice / 100;
  }

  // 3. Fast Add to Cart triggering your Vercel App Proxy Draft Order
  const atcButton = document.querySelector('.single-add-to-cart-button');
  if (atcButton) {
    atcButton.addEventListener('click', async function (e) {
      e.preventDefault();
      
      this.classList.add('is-loading');
      this.innerText = 'Creating Secure Checkout...';

      const customProperties = [];
      Object.keys(selectedConfig).forEach(cat => {
        if (selectedConfig[cat]) {
          customProperties.push({ key: cat.charAt(0).toUpperCase() + cat.slice(1), value: selectedConfig[cat].name });
        }
      });

      const finalPrice = window.currentCalculatedPrice || (data.basePrice / 100);
      
      // FIX: Grab the base variant ID so the checkout shows the product image
      const baseVariantId = document.querySelector('input[name="id"], select[name="id"]')?.value;

      try {
        const response = await fetch('/apps/configurator/api/create-checkout', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            title: data.productTitle,
            totalPrice: finalPrice,
            properties: customProperties,
            // FIX: Pass the Variant ID to the backend
            variantId: baseVariantId ? `gid://shopify/ProductVariant/${baseVariantId}` : null
          })
        });

        const resData = await response.json();

        if (resData.checkoutUrl) {
          window.location.href = resData.checkoutUrl; 
        } else {
          throw new Error(resData.error || 'Checkout creation failed');
        }
      } catch (error) {
        console.error('Checkout Error:', error);
        this.classList.remove('is-loading');
        this.innerText = 'Error - Try Again';
      }
    });
  }
});